module.exports = __webpack_public_path__ + "static/media/services_consulting.ae4b0edc.jpg";